import lazySizes from 'lazysizes';

lazySizes.init();

// additional modules
import './calculator.js';
import './menu.js';
import './mobile-menu.js';
import './nutritional-modal.js';
import './recipe-modal.js';
import './recipes.js';
import './faq.js';
import './homepage-video.js';

function handleFirstTab(e) {
  if (e.keyCode === 9) { // the "I am a keyboard user" key
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
  }
}

window.addEventListener('keydown', handleFirstTab);